import { createComboboxController } from './combobox/controller'

// Private types ---------------------------------------------------------------

type ComboboxHookState = Readonly<{
  cleanup: () => void
  disconnected: () => void
  reconnected: () => void
  sync: () => void
}>

type ComboboxHook = {
  readonly el: HTMLElement
  comboboxState?: ComboboxHookState
  pushEvent: (
    event: string,
    payload: Record<string, unknown>,
    onReply?: (reply: unknown, ref: number) => unknown
  ) => unknown
  pushEventTo: (
    target: string,
    event: string,
    payload: Record<string, unknown>,
    onReply?: (reply: unknown, ref: number) => unknown
  ) => unknown
}

// Public hook -----------------------------------------------------------------

export const FacadeCombobox = {
  // Mounts one controller for both single and multi-value modes.
  mounted(this: ComboboxHook): void {
    this.comboboxState = createComboboxController(this.el, this)
  },

  // Reapplies semantic state after a LiveView patch.
  updated(this: ComboboxHook): void {
    this.comboboxState?.sync()
  },

  // Pauses remote work and interaction while LiveView is disconnected.
  disconnected(this: ComboboxHook): void {
    this.comboboxState?.disconnected()
  },

  // Restores server state and refreshes remote data after reconnection.
  reconnected(this: ComboboxHook): void {
    this.comboboxState?.reconnected()
  },

  // Releases every listener, observer, timer, and live-prop adapter.
  destroyed(this: ComboboxHook): void {
    this.comboboxState?.cleanup()
    this.comboboxState = undefined
  }
}
